import fetch from '@/utils/request'

const request = (rest = {}) => fetch({ ...rest, privateFlag: true })

export default {
  // 产品列表（药企全部）
  getProductPackageList(data = {}) {
    return request({
      url: '/business/companyProductPackage/getProductPackageList',
      method: 'POST',
      data
    })
  },
  // 子公司下的产品包列表
  getCompanyProductPackageList(data) {
    return request({
      url: '/business/companyProductPackage/companyProductPackageList',
      method: 'POST',
      data
    })
  },
  // 子公司产品包下拉列表
  getCompanyProductPackageSelectList(data) {
    return request({
      url: '/business/companyProductPackage/availableProductPackageList',
      method: 'POST',
      data
    })
  },
  // 添加产品包
  addCompanyProductPackage(data) {
    return request({
      url: `/business/companyProductPackage/addCompanyProductPackage`,
      method: 'POST',
      data
    })
  },
  // 修改产品包
  updateCompanyProductPackage(data) {
    return request({
      url: `/business/companyProductPackage/updateCompanyProductPackage`,
      method: 'POST',
      data
    })
  },
  // 删除产品包
  deletedCompanyProductPackage(data) {
    return request({
      url: `/business/companyProductPackage/deletedCompanyProductPackage`,
      method: 'POST',
      data
    })
  },
  // 产品包详情
  getCompanyProductPackageInfo(data) {
    return request({
      url: `/business/companyProductPackage/getCompanyProductPackageInfo`,
      method: 'POST',
      data
    })
  }
}
